import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export default function Reveal() {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
    const scale = useTransform(scrollYProgress, [0, 0.5, 1], [1.4, 1, 0.85]);
    const opacity = useTransform(scrollYProgress, [0, 0.15, 0.6, 1], [0, 1, 1, 0.6]);

    return (
        <section id="reveal" ref={ref} className="relative min-h-[140vh] flex items-center justify-center border-t border-border overflow-hidden" data-testid="phase-reveal">
            <div className="absolute inset-0 bg-grid-amber opacity-60 animate-grid-drift" />
            <NeuralGrid />
            <motion.div style={{ scale, opacity }} className="sticky top-1/4 z-10 text-center px-6">
                <div className="text-[10px] font-mono uppercase tracking-[0.5em] text-signal mb-6">// SYSTEM ONLINE</div>
                <h1 className="font-display font-black uppercase leading-[0.82] tracking-[-0.04em] text-[28vw] sm:text-[22vw] lg:text-[20vw] text-ghost glow-amber">
                    APIB
                </h1>
                <div className="mt-8 max-w-3xl mx-auto">
                    <p className="font-mono text-xs sm:text-sm uppercase tracking-[0.35em] text-signal mb-3">
                        AUTONOMOUS PROCESSING & INTELLIGENCE BACKBONE
                    </p>
                    <p className="font-display text-2xl sm:text-3xl lg:text-4xl tracking-tight text-ghost">
                        The infrastructure layer for autonomous intelligence.
                    </p>
                </div>
                <div className="mt-12 inline-flex items-center gap-3 text-[10px] font-mono text-muted uppercase tracking-[0.3em]">
                    <span className="w-1.5 h-1.5 bg-signal animate-pulse-glow" />
                    Scroll to inspect the backbone
                </div>
            </motion.div>
        </section>
    );
}

function NeuralGrid() {
    return (
        <svg className="absolute inset-0 w-full h-full opacity-40" viewBox="0 0 1200 800" preserveAspectRatio="xMidYMid slice">
            <defs>
                <radialGradient id="rg" cx="50%" cy="50%">
                    <stop offset="0%" stopColor="#FFB000" stopOpacity="0.9" />
                    <stop offset="100%" stopColor="#FFB000" stopOpacity="0" />
                </radialGradient>
            </defs>
            {Array.from({ length: 60 }).map((_, i) => {
                const cx = (i * 79) % 1200;
                const cy = (i * 113) % 800;
                return <circle key={i} cx={cx} cy={cy} r={1.4} fill="#FFB000">
                    <animate attributeName="opacity" values="0;1;0" dur={`${2 + (i % 5)}s`} begin={`${i * 0.07}s`} repeatCount="indefinite" />
                </circle>;
            })}
            {Array.from({ length: 30 }).map((_, i) => {
                const x1 = (i * 41) % 1200, y1 = (i * 137) % 800;
                const x2 = ((i + 4) * 41) % 1200, y2 = ((i + 4) * 137) % 800;
                return <line key={`l-${i}`} x1={x1} y1={y1} x2={x2} y2={y2} stroke="#FFB000" strokeOpacity="0.22" strokeWidth="0.6" />;
            })}
        </svg>
    );
}
